















































































import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import { Funcionalidades } from '@/config/funcionalidades';
import {
  GridOptions,
  GridApi,
  ColDef,
  GridReadyEvent,
  ICellRendererParams,
} from 'ag-grid-community';
import { ComponenteBase, Accion } from '@/views/base/ComponenteBase';
import {
  codigoAccionesMenuItem,
  CodigoAccion,
  PermisoAccion,
} from '@/views/base/VariablesPermisos';
import moment from 'moment';
import { AxiosVue } from '@/AxiosVue';
import { EstadoEntidad, ServicioProxy, TipoRol } from '@/config/enums';
import CrearAlertaModal from './CrearAlerta.vue';
import EditarAlertaModal from './EditarAlerta.vue';
import { actionsEvent } from '@/setup';

@Component({
  components: {
    MantenedorGridSinCodigo,
    CrearAlertaModal,
    EditarAlertaModal,
  },
})
export default class AlertasPantalla extends ComponenteBase {
  readonly funcionalidad: Funcionalidades = Funcionalidades.FugaCombustible;
  accionesTotales: PermisoAccion[] = [];

  search: string = '';
  infoItems: any[] = [];
  showInfoDialog: boolean = false;
  mostrarModalCrear: boolean = false;
  mostrarModalEditar: boolean = false;
  alerta: any = [];
  edit: boolean = false;

  gridOptions: GridOptions;
  gridApi: GridApi;
  columnDefs: Array<ColDef> = [];
  serverSide: any;
  axios: AxiosVue = new AxiosVue(ServicioProxy.Metabase);

  constructor() {
    super();

    this.columnDefs = [
      {
        headerName: 'Id',
        field: 'id',
        resizable: true,
        sortable: true,
        hide: true,
        cellStyle: { textAlign: 'left' },
        width: 90,
        minWidth: 80,
      },
      {
        headerName: 'Nombre',
        field: 'jconf.Nombre',
        resizable: true,
        sortable: true,
        hide: false,
        cellStyle: { textAlign: 'left' },
        width: 160,
        minWidth: 80,
      },
      {
        headerName: 'Tiempo Análisis (minutos)',
        field: 'jconf.tiempo_analisis',
        resizable: true,
        sortable: true,
        hide: false,
        cellStyle: { textAlign: 'left' },
        width: 160,
        minWidth: 80,
        valueGetter: function(params) {
          return params.data.jconf.tiempo_analisis / 60;
        },
      },
      {
        headerName: 'Variación Combustible (% porcentual)',
        field: 'jconf.variacion_combustible',
        resizable: true,
        sortable: true,
        hide: false,
        cellStyle: { textAlign: 'left' },
        width: 160,
        minWidth: 80,
      },
      {
        headerName: 'Velocidad Detención (Km/Hr)',
        field: 'jconf.velocidad_detencion',
        resizable: true,
        sortable: true,
        hide: false,
        cellStyle: { textAlign: 'left' },
        width: 160,
        minWidth: 80,
      },
      {
        headerName: 'Vehículos',
        field: 'patentes',
        type: 'medalColumn',
        tooltipField: 'country',
        width: 160,
        minWidth: 80,
        cellRenderer: () => {
          return '<i class="material-icons" id="5545" title="Ver Filtros" style="width: 28px; height: 28px; margin-top: 10%" >info_outlined</i>';
        },
        cellStyle: () => {
          return { cursor: 'pointer' };
        },
        onCellClicked: this.handleClickInfo,
        columnGroupShow: 'closed',
      },
    ];

    this.gridOptions = {
      pagination: true,
      paginationPageSize: 6,
      rowModelType: 'normal',
      columnDefs: this.columnDefs,
      serverSideDatasource: this.serverSide,
      rowSelection: 'single',
      columnTypes: {
        fecha: {
          sortable: true,
          resizable: true,
          filter: false,
        },
      },
      suppressCsvExport: true,
      suppressExcelExport: true,
      onGridReady: this.handleGridReady,
      onModelUpdated: this.onModelUpdated,
      onSelectionChanged: this.onSelectionChanged,

      processCellForClipboard: ({ value }) => {
        return value instanceof moment
          ? this.formatFecha(value as moment.Moment)
          : value;
      },
      onGridSizeChanged: event => {
        //event.api.sizeColumnsToFit();
      },
    };
  }

  mounted() {
    this.getConfiguracion();
    actionsEvent.onEditar(this.handleEditarClick);
    actionsEvent.onVerDetalle(this.handleVerDetalleClick);
    actionsEvent.onEliminar(this.handleEliminarClick);
  }

  handleCrear() {
    this.edit = false;
    this.alerta = {};
    this.mostrarModalCrear = true;
  }

  handleVerDetalleClick(params: ICellRendererParams) {
    this.alerta = params.data.jconf;
    this.edit = true;
    this.mostrarModalCrear = true;
  }

  handleEliminarClick(params: ICellRendererParams) {
    this.delete(params.data.id);
  }

  handleEditarClick(params: ICellRendererParams) {
    this.alerta = params.data;
    this.alerta.id_conf = params.data.id;
    this.edit = false;
    this.mostrarModalEditar = true;
  }

  async delete(id: any) {
    let self = this;
    this.loadingService.showLoading();
    return this.axios.http
      .post(
        'Metabase/PostgenericA/conf_fuga_combustible/delConfiguracionById',
        {
          id_cliente: this.getClientID().toString(),
          id_conf: id,
        }
      )
      .then((data: any) => {
        self.$snotify.success('Eliminado con éxito', { timeout: 3000 });
        this.getConfiguracion();
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  onFilterTextBoxChanged() {
    if (this.search === null) this.search = '';
    this.gridApi.setQuickFilter(this.search.length > 1 ? this.search : '');
  }

  async getConfiguracion() {
    let self = this;
    this.loadingService.showLoading();
    return this.axios.http
      .post('Metabase/PostgenericA/conf_fuga_combustible/getConfiguraciones', {
        id_cliente: this.getClientID().toString(),
      })
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          data = data.data.data;
          self.gridApi.setRowData(data);
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  handleClickInfo(event: any) {
    this.infoItems = event.value;
    this.showInfoDialog = true;
  }

  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
  }

  onSelectionChanged(params: any) {}

  async handleGridReady(event: GridReadyEvent) {
    this.gridApi = event.api;
  }

  formatFecha(fecha: moment.Moment) {
    return fecha.format('DD/MM/YYYY');
  }

  handleCierreModal() {
    this.showInfoDialog = false;
    this.mostrarModalCrear = false;
    this.mostrarModalEditar = false;

    this.getConfiguracion();
  }
  getClientID(): number {
    return parseInt(localStorage.getItem('clienteDefecto'));
    // return 5216;
  }
}
